import { GET_MASTER_OPTIONS, MASTER_OPTIONS_REQUEST, SET_ADD_MASTER_IN_OPTIONS, SET_UPDATE_MASTER_IN_OPTIONS,
  MASTER_OPTIONS_REQUEST_FAILURE, SET_ACCOUNTS_DATA_IN_OPTIONS, GET_MASTER_ALL_OPTIONS, SET_RELOAD_MASTER_PAYLOAD
 } from "../types";

const initialState = {
  accountsData: [],
  accounts: {
    activeAccountsData: [],
    accountsMap: new Map(),
  },
  allOptions: {},
  options: {},
  loading: false,
  error: null,
  isLoaded: false,
  lastFetchedAt: null
};

const masterOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case MASTER_OPTIONS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_MASTER_ALL_OPTIONS: {
      return {
        ...state,
        allOptions: { ...state.allOptions, ...action.payload },
        loading: false,
        error: null
      }
    }
    case GET_MASTER_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.payload },
        loading: false,
        error: null
      }
    }
    case MASTER_OPTIONS_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case SET_ADD_MASTER_IN_OPTIONS: {
      const { name, data } = action.payload || {};
      const masterData = state.options[name]?.slice(0) || [];
      const allMasterData = state.allOptions[name]?.slice(0) || [];
      return {
        ...state,
        options: {
          ...(state.options || {}),
          [name]: [data, ...masterData],
        },
        allOptions: {
          ...(state.allOptions || {}),
          [name]: [data, ...allMasterData],
        }
      }
    }
    case SET_UPDATE_MASTER_IN_OPTIONS: {
      const { name, id, data } = action.payload || {};
      const masterData = state.options[name]?.slice(0) || [];
      const allMasterData = state.allOptions[name]?.slice(0) || [];
      const uIndex = masterData.findIndex((data) => data.id === id);
      const auIndex = allMasterData.findIndex((data) => data.id === id);
      if (data) {
        masterData.splice(uIndex, 1, { ...data });
        allMasterData.splice(auIndex, 1, { ...data });
      } else {
        masterData.splice(uIndex, 1);
        allMasterData.splice(auIndex, 1);
      }
      return {
        ...state,
        options: {
          ...(state.options || {}),
          [name]: [...masterData],
        },
        allOptions: {
          ...(state.allOptions || {}),
          [name]: [...allMasterData],
        }
      }
    }
    case SET_ACCOUNTS_DATA_IN_OPTIONS: {
      const { accountsData, activeAccountsData, accountsMap } = action.payload || {};
      return {
        ...state,
        accountsData: accountsData || [],
        accounts: {
          activeAccountsData: activeAccountsData || [],
          accountsMap: accountsMap || new Map(),
        }
      }
    }
    case SET_RELOAD_MASTER_PAYLOAD: {
      return {
        ...state,
        ...(action.payload || {})
      }
    }
    default:
      return state;
  }
};

export default masterOptionsReducer;